module.exports = __webpack_public_path__ + "img/icon-back.6025dd60.png";